var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { cssColorValue, desktopMesto, IconArrowTopRight, PopoverNavigation, PopoverNavigationItem, PopoverTrigger, spacer20, spacer24, spacer4, spacer8, } from '@spotify-internal/encore-web';
import React from 'react';
import styled from 'styled-components';
import { ButtonTertiaryLink } from '../Link/Link';
const StyledPopoverNavigation = styled(PopoverNavigation) `
  padding: ${spacer8};

  [dir='rtl'] & * {
    direction: rtl;
    & > svg {
      transform: rotateY(180deg);
    }
  }
`;
const StyledPopoverNavigationLinkText = styled.span `
  && {
    margin-inline-start: ${({ level, iconLeading }) => {
    if (!iconLeading && level === 2) {
        return spacer24;
    }
    if (iconLeading) {
        return spacer8;
    }
    return 0;
}};
    margin-inline-end: ${({ openInNewWindow }) => openInNewWindow ? 'auto' : 0};
  }
`;
const StyledPopoverNavigationLink = styled(ButtonTertiaryLink) `
  cursor: pointer;
  color: ${cssColorValue('textBase')} !important;
  text-decoration: none !important;
  justify-content: flex-start;
  width: 100%;
  ${desktopMesto};

  &:active,
  &:hover,
  &:focus {
    transform: none;
  }

  &:active {
    color: ${cssColorValue('textBase')} !important;
    opacity: 1;
  }

  & > * {
    margin: 0;
  }

  &:focus {
    & ${StyledPopoverNavigationLinkText} + span > svg {
      display: block;
    }
  }

  &::after {
    inline-size: ${({ level, iconLeading }) => {
    if (!iconLeading && level === 2) {
        return `calc(100% - ${spacer24})`;
    }
    return '100%';
}};
    margin-inline-start: ${({ level, iconLeading }) => {
    if (!iconLeading && level === 2) {
        return spacer24;
    }
    return 0;
}};
  }
`;
const StyledPopoverNavigationItem = styled(PopoverNavigationItem) `
  border-radius: ${spacer4};
  cursor: pointer;
  padding-block: calc(${spacer20} / 2);
  padding-inline: ${spacer8};

  & ${StyledPopoverNavigationLinkText} + span > svg {
    display: none;
  }

  &:hover {
    background-color: ${cssColorValue('backgroundElevatedHighlight')};

    & ${StyledPopoverNavigationLinkText} + span > svg {
      display: block;
    }
  }
`;
export const NavBarPopover = ({ children, isOpen, links, onMouseEnter, onMouseLeave, }) => {
    return (React.createElement(PopoverTrigger, { onShow: () => { }, onHide: () => { }, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, placement: PopoverTrigger.bottom, overlay: isOpen && (React.createElement(StyledPopoverNavigation, { arrow: PopoverNavigation.top }, links.map((_a, i) => {
            var { openInNewWindow, href, level, linkText, track, iconLeading } = _a, rest = __rest(_a, ["openInNewWindow", "href", "level", "linkText", "track", "iconLeading"]);
            return (React.createElement(StyledPopoverNavigationItem, { key: i },
                React.createElement(StyledPopoverNavigationLink, Object.assign({ openInNewWindow: openInNewWindow, href: href, iconLeading: iconLeading, level: level, track: track, iconTrailing: openInNewWindow
                        ? () => React.createElement(IconArrowTopRight, { size: "small" })
                        : undefined }, rest),
                    React.createElement(StyledPopoverNavigationLinkText, { openInNewWindow: openInNewWindow, iconLeading: Boolean(iconLeading), level: level }, linkText))));
        }))) }, children));
};
//# sourceMappingURL=Popover.js.map